export default class WatchedDetailsDirective {
    constructor($uibModal, $http) {
        this.$uibModal = $uibModal;
        this.restrict = 'A';
        this.watchedId = null;
        this.$http = $http;
    }

    link(scope, element, attrs) {
        let watchedId = attrs.watchedDetails;

        const modalDetails = (e) => {
            e.preventDefault();

            let modalInstance = this.$uibModal.open({
                animation: 'false',
                size: 'xl',
                template: '<div class="modal-confirmation">\
                                <div class="modal-body" id="modal-body">\
                                    <div ng-if="loading">{{ \'loading_data\' | t }}...</div>\
                                    <div ng-if="!loading" ng-bind-html="htmlContent | trusted"></div>\
                                </div>\
                                <div class="modal-footer">\
                                    <button class="btn btn-outline-primary" type="button" ng-click="downloadPdf()">{{ \'download_pdf\' | t }}</button>\
                                    <button class="btn btn-primary" type="button" ng-click="close()">{{ \'close\' | t }}</button>\
                                </div>\
                            </div>',
                controller: ['$scope', '$uibModalInstance', '$http', 'watchedId', function($scope, $uibModalInstance, $http, watchedId) {
                    $scope.watchedId = watchedId;
                    $scope.$http = $http;
                    $scope.htmlContent = '';
                    $scope.loading = true;

                    $scope.close = function () {
                        $uibModalInstance.close();
                    };

                    $scope.getHtmlContent = () => {
                        $http.get(`/api/watched/details/${watchedId}`).then(response => {
                            $scope.htmlContent = response.data.data;
                            $scope.loading = false;
                        });
                    }

                    $scope.downloadPdf = () => {
                        document.location.href = (locale === 'en' ? '/en' : '') + `/api/watched/pdf/${watchedId}`;
                    }

                    $scope.getHtmlContent();

                }],
                resolve: {
                    watchedId: () => {
                        return watchedId;
                    },
                    $http: () => {
                        return this.$http;
                    }
                }
            });

            modalInstance.result.then(function () {
            }, function () {});
        }

        element.bind('click', modalDetails);
    }



    static directiveFactory($uibModal, $http) {
        'ngInject';

        return new WatchedDetailsDirective($uibModal, $http);
    }
}
